import { RootState } from '@/modules/ewwms/store';
import { ActionContext, ActionTree } from 'vuex';
import { Mutations, MutationTypes } from './mutations';
import { State } from './state';

import { useEwwmsCommonStore } from '../../ewwmsCommonStore';

import ApiService from '@/modules/ewwms/services/ApiService';
import { Listeartikel } from '@/modules/ewwms/models/Lager/ListeartikelModels';

export enum ActionTypes {
  GetBestand = 'GETBESTAND',
  GetUpdateBestand = 'GETUPDATEBESTAND',
  ResetBestand = 'RESETBESTAND',

  RemoveBestandLocal = 'REMOVEBESTANDLOCAL',
}

type ActionArguments = Omit<ActionContext<State, RootState>, 'commit'> & {
  commit<K extends keyof Mutations>(key: K, payload?: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
};

export type Actions = {
  [ActionTypes.GetBestand](context: ActionArguments, data: string): Promise<void>;
  [ActionTypes.GetUpdateBestand](context: ActionArguments, data: string): Promise<void>;
  [ActionTypes.ResetBestand](context: ActionArguments): void;
  [ActionTypes.RemoveBestandLocal](context: ActionArguments, data: number): Promise<void>;
};

export const actions: ActionTree<State, RootState> & Actions = {
  async [ActionTypes.GetBestand]({ commit }, data) {
    const commonStore = useEwwmsCommonStore();
    const status = commonStore.status;
    status.getBestandLoading = true;
    status.bestandErrorMsg = '';
    commonStore.setStatus(status);

    commit(MutationTypes.SetBestand, new Array<Listeartikel>());

    return ApiService.getLagerortBestand(data)
      .then((res) => {
        const bestand: Array<Listeartikel> = res.data;
        commit(MutationTypes.SetBestand, bestand);
      })
      .catch((error) => {
        console.log(error);
        status.bestandErrorMsg = error.toString();
      })
      .finally(() => {
        status.getBestandLoading = false;
        commonStore.setStatus(status);
      });
  },

  async [ActionTypes.GetUpdateBestand]({ commit }, data) {
    const commonStore = useEwwmsCommonStore();
    const status = commonStore.status;
    status.bestandErrorMsg = '';
    commonStore.setStatus(status);

    return ApiService.getLagerortBestand(data)
      .then((res) => {
        const bestand: Array<Listeartikel> = res.data;
        commit(MutationTypes.SetBestand, bestand);
      })
      .catch((error) => {
        console.log(error);
        status.bestandErrorMsg = error.toString();
        commonStore.setStatus(status);
      });
  },

  [ActionTypes.ResetBestand]({ commit }) {
    commit(MutationTypes.SetBestand, new Array<Listeartikel>());
  },

  async [ActionTypes.RemoveBestandLocal]({ commit }, data) {
    commit(MutationTypes.RemoveBestand, data);
  },
};
